import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import styles from "./customeSelectBox.styles.module.scss";
import { ICustomeSelectBox } from "./type";
import { customSelectBoxStyles } from "./customSelectBoxStyles";

const CustomSelectBox = (props: ICustomeSelectBox) => {
  const {
    onSelect,
    option,
    value,
    isRequired,
    label,
    placeholder,
    className,
    isLoading,
    disabled,
    isCreatable,
  } = props;
  return (
    <div className={`${styles.inputBox}`}>
      <label className="form-label">
        {label}
        {isRequired && <span className={styles.requiredSing}>*</span>}
      </label>
      {isCreatable ? (
        <CreatableSelect
          value={value}
          options={option}
          onChange={onSelect}
          placeholder={placeholder}
          styles={customSelectBoxStyles}
          className={`${className ? styles[className] : ""} `}
          isLoading={isLoading || false}
          isDisabled={disabled}
        />
      ) : (
        <Select
          value={value}
          options={option}
          onChange={onSelect}
          placeholder={placeholder}
          styles={customSelectBoxStyles}
          className={`${className ? styles[className] : ""} `}
          isLoading={isLoading || false}
          isDisabled={disabled}
        />
      )}
    </div>
  );
};

export default CustomSelectBox;
